import WebpImage from "@/Components/Front/Blocks/WebpImage";
import FrontText from "@/Components/Front/FrontText";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { Link } from "@inertiajs/react";
import { useTranslation, Trans } from "react-i18next";
import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import FrontRoundedButton from "@/Components/Front/Buttons/FrontRoundedButton";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const Services = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();

    return (
        <FrontLayout breadcrumbs={[{ title: t('breadcrumbs.services'), current: true }]}>
            <FrontSeoMetaTags seo={seo}/>
            <section>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="mt-10 mb-10 font-domine font-bold text-dark-blue-standard" textSize={'38/43-m-24/27'}>
                                <h1>{t('services.h1')}</h1>
                            </FrontText>
                        </Column>
                    </Row>
                </Container>
                <div className="relative xl:mb-25 lg:mb-20 md:mb-16 mb-15">
                    <Container>
                        <Row className='justify-between items-center'>
                            <Column xl={6} lg={6} md={6}>
                                <FrontText className="[&_p]:mb-5 [&_a]:font-semibold" textSize={'16/20'}>
                                    <Trans i18nKey={'services.entryText'} />
                                </FrontText>
                            </Column>
                            
                            <Column xl={5} lg={6} md={6} className='md:mt-0 mt-6'>
                                <WebpImage
                                    className='w-full h-auto rounded-10'
                                    sources={[
                                        {
                                            width: 768,
                                            path: `/storage/images/chodecki-michal-size-767`,
                                            mime: 'jpg'
                                        },
                                        {
                                            width: 1,
                                            path: `/storage/images/chodecki-michal-size-500`,
                                            mime: 'jpg'
                                        }
                                    ]}
                                    alt='Katarzyna Pyś-Fabiańczyk'
                                    fallback={'/storage/images/chodecki-michal'}
                                    seo={{
                                        width: 530,
                                        height: 354
                                    }}
                                />
                            </Column>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="mb-10 font-domine font-bold text-dark-blue-standard" textSize={'38/43-m-24/27'}>
                                <h2>{t('services.h2')}</h2>
                            </FrontText>
                        </Column>
                    </Row>
                    <Row className={`justify-center -mx-11 xl:mb-20 lg:mb-15 mb-10`}>
                        {t('services.services', { returnObjects: true }).map((item, id) => (
                            <Column xl={4} lg={4} md={6} key={item.title + id} className={`mb-10 px-11`}>
                                <div className="shadow-service-box py-8 border-[1px] border-[rgba(5, 29, 65, 0.02)] px-7 rounded-20 flex md:gap-x-8 gap-x-4 h-full">
                                    <img src={`/storage/icons/${item.icon}`} alt={item.title} className="md:w-[93px] w-20 h-auto object-contain" width={93} height={93}/>
                                    <article className="flex flex-col justify-between">
                                        <FrontText textSize={'16/20'} className="font-bold">
                                            <h3>{item.title}</h3>
                                        </FrontText>
                                        <Link href={resolveLocaleRoute(item.link, null, i18n.resolvedLanguage)} className="mt-3 w-max flex items-center">
                                            <FrontRoundedButton title={item.linkText}>
                                                {item.linkText}
                                            </FrontRoundedButton>
                                        </Link>
                                    </article>
                                </div>
                            </Column>
                        ))}
                    </Row>
                </Container>
            </section>

            <section id="quote">
                <Container>
                    <Row className='justify-center'>
                        <Column xl={9} lg={10} md={11} sm={11}>
                            <p className="text-dark-blue-standard font-domine font-bold md:text-20 md:leading-c38 text-17 leading-8 text-center">
                                <span className="iconify-mask-icon-quote mr-1" />
                                    {t('services.quote')}
                                <span className="iconify-mask-icon-quote rotate-180 -mb-3 ml-1" />
                            </p>
                        </Column>
                    </Row>
                </Container>
            </section>

            <section className="xl:mt-30 lg:mt-25 md:mt-20 mt-15 xl:mb-36 lg:mb-30 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents}/>
            </section>
        </FrontLayout>
    )
}

export default Services;